<template>
  <div class="vertical-pb -helper--flex column space-between">
   
    <div class="routes-wrapper -helper--flex column" >
      <div class="route-item -helper--flex align-center" v-if="shouldShowRoutes && !isMultiBusinessFlow">
        <div class="circle" :class="activeRoute == 'partner-welcome' ? 'active' : ''">1</div>
        <span
          :class="activeRoute == 'partner-welcome' ? 'lili-color' : ''"
          class="route-indication"
          >Personal Details</span
        >
      </div>
      <div class="route-item -helper--flex align-center" v-if="shouldShowRoutes">
        <div class="circle" :class="activeRoute == 'partner-business' || activeRoute == 'addOwner' ? 'active' : ''">{{ isMultiBusinessFlow ? '1' : '2' }}</div>
        <span
          :class="activeRoute == 'partner-business' || activeRoute == 'addOwner' ? 'lili-color' : ''"
          class="route-indication"
          >Business Details</span
        >
      </div>
      <div class="route-item -helper--flex align-center" v-if="shouldShowRoutes">
        <div class="circle" :class="activeRoute == 'plan' ? 'active' : ''" >{{ isMultiBusinessFlow ? '2' : '3' }}</div>
        <span
          :class="activeRoute == 'plan' ? 'lili-color' : ''"
          class="route-indication"
          >Choose a Plan</span
        >
      </div>
      <div class="route-item -helper--flex align-center" v-if="shouldShowRoutes">
        <div class="circle" :class="(activeRoute == 'review' || activeRoute == 'kybPending') ? 'active' : ''" >{{ isMultiBusinessFlow ? '3' : '4' }}</div>
        <span
          :class="(activeRoute == 'review' || activeRoute == 'kybPending') ? 'lili-color' : ''"
          class="route-indication"
          >Confirmation</span
        >
      </div>
    </div>
    <div class="footer">
      <span class="main-logo-dark-blue" />
      <div class="content">
        <div class="title">Lili Customer Service</div>
        <div><a href="mailto:support@lili.co">Email our support team</a> or call us</div>
        <div>(855) 545-4380</div>
        <div>9:00am-7:00pm EST Monday - Friday</div>
      </div>
      <div class="separator"></div>
      <div class="disclaimer">
        Lili is a financial technology company, not a bank.
        {{`Banking services provided by ${this.dynamicDisclaimer}, Member FDIC.`}}
      </div>
     
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    activeRoute () {
      return this.$route.name
    },
    visitedRoutes () {
      return this.$store.getters['onboarding/data'].visitedRoutes
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    dynamicDisclaimer () {
      if (this.customerData.institutionData.bankType === 'CHOICE') return 'Choice Financial Group'
      if (this.customerData.institutionData.bankType === 'SUNRISE') return 'Sunrise Banks, N.A.'
    },
    shouldShowRoutes () {
      const HIDDEN_ROUTES = ['verificationCenter', 'kybThankYou', 'approved', 'accountExists',
        'noContinueDone', 'noContinueChecking', 'DebitCardName', 'checkDocs', 'generalError', 'ContinueOtherBusiness']
      return !HIDDEN_ROUTES.includes(this.activeRoute)
    },
    isMultiBusinessFlow () {
      return this.$store.getters['onboarding/isMultiBusinessFlow']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/VerticalProgressBar.vue